import moment from "moment";
import React, {useDebugValue} from "react";
import {useState} from "react";
import {useDispatch} from "react-redux";
import {isMobile} from "../../../utils/commonMethods";
import {getEventDetails} from "../../event/redux/events.actions";
import HomeBuySellComp from "./HomeBuySellComp";
import MultiChild from "./MultiChild";
import TradeCard from "./tradeCard";

const ParentProbeCard = ({
  trade,
  onCallback,
  isContestCard,
  isMulti,
  isParticipent,
  contestStartTime,
  timerExpireCallback = () => {},
  liveStatsId,
}) => {
  const dispatch = useDispatch();
  const [orderBookSelectedData, setOrderBookSelectedData] = useState({
    callvalue: "Y",
    isShow: false,
  });
  const onYesNoBtnPress = (e, isYes) => {
    if (isMobile()) {
      if (isContestCard) {
        if (
          isParticipent &&
          moment().unix(new Date()) >= moment.utc(contestStartTime).unix()
        ) {
        } else {
          onCallback(trade);
          return;
        }
      }
      e.stopPropagation();
      const data = {
        callvalue: isYes ? "Y" : "N",
        isShow: true,
      };

      if (trade?.is_price_editable) {
        dispatch(getEventDetails(trade?.id));
      }
      //subscribeToOpen();
      setOrderBookSelectedData(data);
    } else {
      onCallback(trade);
    }
  };
  const onBottomSheetClose = () => {
    setOrderBookSelectedData(null);
  };

  if(trade?.title.includes("Men's Indian")){
    console.log('trade', trade);
  }

  return (
    <>
      {isMulti ? (
        <MultiChild
          trade={trade}
          isContestCard={isContestCard}
          onBtnPress={onYesNoBtnPress}
        />
      ) : (
        <TradeCard
          trade={trade}
          onBtnPress={onYesNoBtnPress}
          isContestCard={isContestCard}
          timerExpireCallback={timerExpireCallback}
        />
      )}
      <HomeBuySellComp
        _eventInfo={trade}
        onBottomSheetClose={onBottomSheetClose}
        isShow={orderBookSelectedData?.isShow}
        isContestCard={isContestCard}
        orderBookSelectedData={orderBookSelectedData}
        liveStatsId={liveStatsId}
      />
    </>
  );
};

export default ParentProbeCard;
